import { BaseRouteService } from 'core/services';

class TaskCommentNotificationRouteService extends BaseRouteService {
    constructor() {
        super('task-comment-notifications');
    }
    
    batchUpdate(resource) {
        return super.batchUpdate(`${this.base}/batch`, resource);
    }

    count(id) {
        return super.get(this.base + '/num-by-user/{id}', id);
    }
}

export default TaskCommentNotificationRouteService;